import { render, staticRenderFns } from "./salarydeal.vue?vue&type=template&id=6bcc434b"
import script from "./salarydeal.vue?vue&type=script&lang=js"
export * from "./salarydeal.vue?vue&type=script&lang=js"
import style0 from "./salarydeal.vue?vue&type=style&index=0&id=6bcc434b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports